export default "__VITE_ASSET__DrbhZUZp__"